/*
 * @Author: Daokai Huo
 * @Date: 2022-12-12 13:43:12
 * @LastEditTime: 2023-03-02 08:29:04
 * @Description:
 */
import Layout from '@/layout'
import LayoutView from '@/layout/layout'

const ApprovalRouter = {
	path: '/approval',
	component: Layout,
	redirect: 'approval',
	name: '审批',
	id: 1300000,
	meta: {
		title: '审批',
		icon: 'chart'
		// roles: [1300000]
	},
	children: [
		{
			path: 'approvalManage',
			component: LayoutView,
			name: '审批管理',
			id: 1310000,
			meta: {
				title: '审批管理',
				noCache: true
				// roles: [1310000]
			},
			redirect: 'approvalManage',
			children: [
				{
					path: 'approvalProcess',
					component: () => import('@/leniuview/approvalManage/approval'),
					name: '审批配置流程',
					id: 203070,
					meta: { title: '审批配置流程', noCache: true, roles: [203060] }
				},
				{
					path: 'approvedList',
					component: () => import(/* webpackChunkName: "approvedList" */ '@/leniuview/approvalManage/approvedList'),
					name: '已审批',
					id: 1311000,
					meta: { title: '已审批', noCache: true }
				},
				{
					path: 'approvalPending',
					component: () => import(/* webpackChunkName: "approvalPending" */ '@/leniuview/approvalManage/approvalPending'),
					name: '待审批',
					id: 1311000,
					meta: { title: '待审批', noCache: true }
				}
			]
		}
	]
}

export default ApprovalRouter
